import React, { useState } from 'react';
import QuizQuestion from './ArithmeticQuizQuestion';

// Algebra Questions for Grade 7
const generateAlgebraQuestion = () => {
  const num1 = Math.floor(Math.random() * 10) + 1;
  const num2 = Math.floor(Math.random() * 10) + 1;
  const correctAnswer = num1 * num2;

  const answers = [correctAnswer];
  while (answers.length < 3) {
    const wrongAnswer = Math.floor(Math.random() * 100);
    if (!answers.includes(wrongAnswer)) {
      answers.push(wrongAnswer);
    }
  }

  const shuffledAnswers = answers.sort(() => Math.random() - 0.5);
  return {
    question: `Solve: ${num1}x = ${correctAnswer}, find x.`,
    answers: shuffledAnswers,
    correct: num1.toString(),
  };
};

// Trigonometry Questions for Grade 7
const generateTrigonometryQuestion = () => {
  const angle = Math.floor(Math.random() * 90) + 1;
  const correctAnswer = Math.round(Math.sin((angle * Math.PI) / 180) * 100) / 100;

  const answers = [correctAnswer];
  while (answers.length < 3) {
    const wrongAnswer = Math.round(Math.random() * 1 * 100) / 100;
    if (!answers.includes(wrongAnswer)) {
      answers.push(wrongAnswer);
    }
  }

  const shuffledAnswers = answers.sort(() => Math.random() - 0.5);
  return {
    question: `What is sin(${angle}°)?`,
    answers: shuffledAnswers,
    correct: correctAnswer.toString(),
  };
};

// Calculus Questions for Grade 7
const generateCalculusQuestion = () => {
  const correctAnswer = "Basic calculus isn't typically covered in Grade 7!";
  return {
    question: "Is Calculus a common topic in Grade 7 math?",
    answers: ["Yes", "No", correctAnswer],
    correct: "No",
  };
};

// Miscellaneous Questions for Grade 7
const generateMiscellaneousQuestion = () => {
  const num1 = Math.floor(Math.random() * 50) + 1;
  const num2 = Math.floor(Math.random() * 50) + 1;
  const correctAnswer = num1 + num2;

  const answers = [correctAnswer];
  while (answers.length < 3) {
    const wrongAnswer = Math.floor(Math.random() * 100);
    if (!answers.includes(wrongAnswer)) {
      answers.push(wrongAnswer);
    }
  }

  const shuffledAnswers = answers.sort(() => Math.random() - 0.5);
  return {
    question: `What is ${num1} + ${num2}?`,
    answers: shuffledAnswers,
    correct: correctAnswer.toString(),
  };
};

const questions = [
    { topic: 'Algebra', generate: generateAlgebraQuestion },
    { topic: 'Trigonometry', generate: generateTrigonometryQuestion },
    { topic: 'Calculus', generate: generateCalculusQuestion },
    { topic: 'Miscellaneous', generate: generateMiscellaneousQuestion },
  ];
  
  export const getRandomQuestion = (topic) => {
    const topicQuestions = questions.find(q => q.topic === topic);
    return topicQuestions ? topicQuestions.generate() : null;
  };

function ArithmeticGrade7() {
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [topic, setTopic] = useState(null); // To store selected topic

  const handleTopicSelection = (selectedTopic) => {
    setTopic(selectedTopic);
    switch (selectedTopic) {
      case 'Algebra':
        setCurrentQuestion(generateAlgebraQuestion());
        break;
      case 'Trigonometry':
        setCurrentQuestion(generateTrigonometryQuestion());
        break;
      case 'Calculus':
        setCurrentQuestion(generateCalculusQuestion());
        break;
      case 'Miscellaneous':
        setCurrentQuestion(generateMiscellaneousQuestion());
        break;
      default:
        setCurrentQuestion(null);
    }
  };

  return (
    <div>
      <h2>Grade 7 Arithmetic Quiz</h2>
      {/* Display Topic Selection */}
      <div>
        <h3>Select a topic:</h3>
        <button onClick={() => handleTopicSelection('Algebra')}>Algebra</button>
        <button onClick={() => handleTopicSelection('Trigonometry')}>Trigonometry</button>
        <button onClick={() => handleTopicSelection('Calculus')}>Calculus</button>
        <button onClick={() => handleTopicSelection('Miscellaneous')}>Miscellaneous</button>
      </div>

      {/* Show Quiz Question only if a topic is selected */}
      {currentQuestion && (
        <div>
          <QuizQuestion question={currentQuestion} handleAnswer={(answer) => {
            if (answer.toString() === currentQuestion.correct) {
              alert("Correct!");
            } else {
              alert("Wrong answer.");
            }
            handleTopicSelection(topic); // Load next question from the same topic
          }} />
        </div>
      )}
    </div>
  );
}

export default ArithmeticGrade7;
